import { render, staticRenderFns } from "./BindCompare.vue?vue&type=template&id=28548920&"
import script from "./BindCompare.vue?vue&type=script&lang=js&"
export * from "./BindCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports